import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import { formatCurrency } from '../../../utils/formatters';

/**
 * HighlightCard - A prominent card for the most important metric
 * Used to display key financial information with visual emphasis
 */
const HighlightCard = ({ title, value, currency = 'BRL' }) => (
  <Card
    variant="outlined"
    sx={{
      mb: 2,
      borderColor: 'success.light',
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      bgcolor: 'rgba(29, 165, 122, 0.05)',
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        left: 0,
        top: 0,
        bottom: 0,
        width: '4px',
        bgcolor: 'success.main',
      }
    }}
  >
    <CardContent sx={{ py: 2 }}>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        {title}
      </Typography>
      <Typography variant="h4" component="div" sx={{ color: 'text.primary', fontWeight: '600' }}>
        {formatCurrency(value, currency)}
      </Typography>
    </CardContent>
  </Card>
);

HighlightCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  currency: PropTypes.string
};

export default HighlightCard;